import type { Product } from '~/models/Product'
import type { BaseItem } from '~/models/Content/BaseItem'

export default () => {
  const isUpcomingView = (product: Product, item?: BaseItem) => product.aunivers.relatedLocations.upcomingContentLocationId
    ? item?.pathString.includes(`/${product.aunivers.relatedLocations.upcomingContentLocationId}/`)
    : false

  const isArchiveView = (product: Product, item?: BaseItem) => product.aunivers.relatedLocations.archivedContentLocationId
    ? item?.pathString.includes(`/${product.aunivers.relatedLocations.archivedContentLocationId}/`)
    : false

  return {
    isUpcomingView,
    isArchiveView,
  }
}
